export const ERROR_MODAL_OPEN = 'ERROR_MODAL_OPEN';
export const ERROR_MODAL_CLOSE = 'ERROR_MODAL_CLOSE';
